import React, { Component } from 'react'
import { autobind } from 'core-decorators'

import PaneListNav from './PaneListNav'
import PaneListBody from './PaneListBody'

export default class PaneList extends Component {

  constructor(props) {
    super(props)
    this.state = {
      district: 'all-districts',
      filter: ''
    }
  }

  @autobind
  handleListChange({ target: { name, value } }) {
    this.setState({
      ...this.state,
      [name]: value
    })
  }

  render() {
    return (
      <div className="list-view-container vertical user-indentifications-list">
        <div className="vertical v-scrollable">
          <PaneListNav
            onChange={this.handleListChange}
            district={this.state.district}
            filter={this.state.filter}
          />
          <PaneListBody
            district={this.state.district}
            filter={this.state.filter}
          />
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/user/components/PaneList.js